(function () {
    'use strict';

    angular
        .module("skillsApp")
        .directive("assetsList", assetsList);

    function assetsList() {
        return {
            restrict: "E",
            templateUrl: "/app/directives/assets-list.tpl.html",
            scope: {
                assets: "=",
                userQualityId: "=",
                editMode: "@"
            },
            controller: AssetsListController,
            controllerAs: 'vm',
            bindToController: true
        };

        function AssetsListController(dataService) {
            var vm = this;

            vm.download = download;
            vm.remove = remove;

            function download(entity) {
                
                dataService.getAsset(vm.userQualityId, entity.id)
                    .then(response => {
                        if (response.error) {
                            logger.error(response.error);
                        } else {
                            var filename = response.headers('file-name');
                            var contentType = response.headers('content-type') || 'application/octet-stream';
                            var blob = new Blob([response.data], { type: contentType });
                            saveAs(blob, filename);
                        }
                    });
            }

            function remove(entity) {
                vm.assets.splice(vm.assets.indexOf(entity), 1);
            }
        }
    }
})();